import Cropper from 'react-easy-crop'
import { createPortal } from 'react-dom'
import { useState } from 'react'
import { getCroppedImg } from './utils'

const CroppImage = ({
  toggle,
  imageSrc,
  setCroppedImage,
}: {
  toggle?: () => void
  imageSrc: string
  setCroppedImage: (value: string, file: File) => void
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }

  const getFileFromBlobUrl = (blobUrl: string) => {
    return fetch(blobUrl)
      .then(response => response.blob())
      .then(blob => new File([blob], '', { type: blob.type }));
  };

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation
      )

      const file = await getFileFromBlobUrl(croppedImage)
      setCroppedImage(croppedImage, file)
      toggle()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    createPortal(
      <div className='h-view w-full fixed top-0 left-0' style={{ zIndex: 9999, background: 'rgba(25, 25, 25, 1)' }}>
        <div className="w-full h-full relative pt-4 px-4 flex flex-col">
          <div className="w-full relative flex items-center justify-center flex-1">
            <Cropper
              image={imageSrc}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={1 / 1}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              onTouchRequest={(e) => {
                e.stopPropagation()
                return true
              }}
            />
          </div>
          <div className='py-8 flex items-center justify-between w-full'>
            <button type='button' className='text big font-bold' onClick={toggle}>CANCELAR</button>
            <button className='button-edit' type='button' onClick={showCroppedImage}><p>OK</p></button>
          </div>
        </div>
      </div>,
      document.body
    )
  )
}

export default CroppImage
